export const us = [{
  field: 'phone',
  method: 'isMobilePhone',
  options: ['en-US'],
  validWhen: true,
  message: 'Phone number must be in format ###-###-####',
}];

export const demo = [{
  field: 'phone',
  method: 'isLength',
  options: [{ min: 12, max: 12 }],
  validWhen: true,
  message: 'Phone number must be in format ###-###-####',
}];
